import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

function CheckoutDialog({
  open,
  onClose,
  selectedRating,
  onSetSelectedRating,
  checkoutLoading,
  lockCheckoutBtn,
  onCheckout,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Buchung abschließen</DialogTitle>
      <DialogContent>
        <Typography variant='body1' sx={{ mb: 3 }}>
          Bitte bewerten Sie die Erfahrung des Kunden:
        </Typography>
        <Box display='flex' justifyContent='center' gap={4}>
          <Tooltip title='Gut'>
            <IconButton
              size='large'
              onClick={() => onSetSelectedRating('good')}
              color={selectedRating === 'good' ? 'success' : 'default'}
            >
              <ThumbUpIcon fontSize='large' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Neutral'>
            <IconButton
              size='large'
              onClick={() => onSetSelectedRating('neutral')}
              sx={selectedRating === 'neutral' ? { color: '#1565c0' } : undefined}
            >
              <SentimentNeutralIcon fontSize='large' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Schlecht'>
            <IconButton
              size='large'
              onClick={() => onSetSelectedRating('bad')}
              color={selectedRating === 'bad' ? 'error' : 'default'}
            >
              <SentimentDissatisfiedIcon fontSize='large' />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          onClick={onCheckout}
          variant='contained'
          disabled={!selectedRating || checkoutLoading || lockCheckoutBtn}
        >
          {checkoutLoading ? <CircularProgress size={24} /> : 'Bestätigen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckoutDialog;
